










import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  value: string
  size: number
}>(
  {
    inheritAttrs: false,
    props: ['value', 'size'],
    components: {
      VueQrcode: () =>
        import(
          // @ts-ignore
          /* webpackChunkName: "vue-qrcode" */ '@chenfengyuan/vue-qrcode'
        ),
    },
  },
  ({ props }) =>
    class {
      options = computed(() => ({
        width: props.size,
        margin: 0,
      }))
    },
)
